import { client, authHeaders } from 'repositories/client';
import { getRequestPath } from 'utils/string';
import { paths } from 'repositories/application/paths';
import {
  InstallSessionResponse,
  ListResponse,
  ShowResponse,
} from 'repositories/application/responseType';

const show = async (
  ownerType: 'users' | 'organizations',
  ownerName: string,
  bundleIdentifier: string,
  revision: string
): Promise<ShowResponse> => {
  const response = await client.get<ShowResponse>(
    getRequestPath(paths.show, {
      ownerType,
      ownerName,
      bundleIdentifier,
      revision,
    }),
    {
      headers: await authHeaders(),
    }
  );
  return response.data;
};

export const APPLICATION_LIST_LIMIT = 10;
const list = async (
  ownerType: 'users' | 'organizations',
  ownerName: string,
  bundleIdentifier: string,
  maxRevision?: number
): Promise<ListResponse> => {
  const params: { [key: string]: number } = {};
  params['limit'] = APPLICATION_LIST_LIMIT;
  if (maxRevision) {
    params['max_revision'] = maxRevision;
  }
  const response = await client.get<ListResponse>(
    getRequestPath(paths.index, { ownerType, ownerName, bundleIdentifier }),
    { params, headers: await authHeaders() }
  );
  return response.data;
};

const installSession = async (
  ownerType: 'users' | 'organizations',
  ownerName: string,
  bundleIdentifier: string,
  revision: string
): Promise<InstallSessionResponse> => {
  const response = await client.post<InstallSessionResponse>(
    getRequestPath(paths.installSession, {
      ownerType,
      ownerName,
      bundleIdentifier,
      revision,
    }),
    {},
    {
      headers: await authHeaders(),
    }
  );
  return response.data;
};

export const application = {
  show,
  list,
  installSession,
};
